import React, { forwardRef } from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export const VariableIcon = forwardRef(function VariableIcon(
  props: SimpleIconInterface,
  ref: React.Ref<SVGSVGElement>
): JSX.Element {
  const { className, height, stroke = IconColors.Grey, width } = props;
  return (
    <SimpleIcon
      ref={ref}
      className={className}
      fill="none"
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M9 5.00769H7.9605C7.64813 4.98175 7.33386 5.02159 7.03737 5.12472C6.74089 5.22785 6.46861 5.39203 6.23759 5.60698C6.00657 5.82193 5.8218 6.08301 5.69488 6.37383C5.56795 6.66466 5.50161 6.97897 5.5 7.29704V9.50114C5.48441 9.90077 5.36223 10.2886 5.14649 10.6233C4.93075 10.958 4.62955 11.227 4.275 11.4015L2 13L4.275 14.5985C4.62966 14.7729 4.93097 15.0418 5.14673 15.3765C5.36249 15.7113 5.4846 16.0992 5.5 16.4989V18.7012C5.50137 19.0194 5.56754 19.3339 5.69436 19.6249C5.82118 19.916 6.00591 20.1773 6.23695 20.3924C6.46799 20.6076 6.74036 20.7719 7.03696 20.8751C7.33356 20.9784 7.64799 21.0183 7.9605 20.9923H9"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M15 5.00798H16.036C16.3486 4.98153 16.6633 5.02099 16.9602 5.12388C17.2571 5.22676 17.5298 5.39086 17.7612 5.60586C17.9926 5.82085 18.1777 6.08209 18.3049 6.37317C18.432 6.66425 18.4984 6.97886 18.5 7.29725V9.50127C18.5156 9.90089 18.6378 10.2887 18.8535 10.6234C19.0693 10.9581 19.3705 11.227 19.725 11.4016L22 13L19.725 14.5984C19.3703 14.7728 19.069 15.0417 18.8533 15.3765C18.6375 15.7112 18.5154 16.0991 18.5 16.4987V18.701C18.4987 19.0195 18.4324 19.3343 18.3054 19.6256C18.1783 19.9169 17.9933 20.1784 17.7619 20.3935C17.5304 20.6087 17.2576 20.773 16.9606 20.876C16.6636 20.979 16.3488 21.0185 16.036 20.992H15"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SimpleIcon>
  );
});
